import React, { useCallback } from 'react';
import cx from 'clsx';

import { IconRcArrowRight } from 'assets';
import './index.css';

type ExpandButtonProps = {
  onClick?: React.MouseEventHandler<HTMLDivElement>;
  className?: string;
  collapsed?: boolean;
};

const useClick = (onClick: ExpandButtonProps['onClick']) =>
  useCallback(
    (e: React.MouseEvent) => {
      e.stopPropagation();
      e.preventDefault();
      onClick?.(e as any);
    },
    [onClick],
  );

export const ExpandButton = ({ onClick, className, collapsed, ...rest }: ExpandButtonProps) => {
  const handleClick = useClick(onClick);

  return (
    <div
      {...rest}
      onClick={handleClick}
      className={cx('db-table-expandButton', collapsed && 'is-collpased', className)}
    />
  );
};

export const ArrowExpandButton = ({
  onClick,
  className,
  collapsed,
  ...rest
}: ExpandButtonProps) => {
  const handleClick = useClick(onClick);

  return (
    <IconRcArrowRight
      {...rest}
      onClick={handleClick}
      className={cx('db-table-expandButtonArrow', collapsed && 'is-collpased', className)}
    />
  );
};

export default ExpandButton;
